import Dropzone from "react-dropzone";
import { Spin, message } from "antd";
import { FiUploadCloud } from "react-icons/fi";
import { useState } from "react";
import { convertApi } from "../helpers/compressUpload";
import { LoadingOutlined } from "@ant-design/icons";
import { uploadImageToS3 } from "../../../config/s3config/s3fileUpload";

const PDFJS = window.pdfjsLib;

function ThumbnailPicker(props: any) {
  const [isloading, setIsloading] = useState(false);

  const convertPdfToImage = async (file: File) => {
    try {
      if (!PDFJS) {
        throw new Error("pdfjsLib is not loaded");
      }
      const uri = URL.createObjectURL(file);
      const pdf = await PDFJS.getDocument({ url: uri }).promise;
      const page = await pdf.getPage(1);
      const viewport = page.getViewport({ scale: 1.5 });

      const canvas = document.createElement("canvas");
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: canvas.getContext("2d"),
        viewport: viewport,
      };

      if (!renderContext.canvasContext) {
        throw new Error("Canvas context is not available");
      }

      await page.render(renderContext).promise;
      const imageUrl = canvas.toDataURL("image/png");
      URL.revokeObjectURL(uri);
      return imageUrl;
    } catch (error) {
      console.error("PDF conversion error:", error);
      message.error("Failed to convert PDF to image");
      return null;
    }
  };

  const uploadImage = async (val: any) => {
    try {
      setIsloading(true);

      if (!val || !val[0]) {
        message.error("No file provided");
        setIsloading(false);
        return;
      }

      const file = val[0];
      const allowedTypes = ["image/jpeg", "image/png"];

      if (!allowedTypes.includes(file.type)) {
        message.error("File Format Not Supported. Use JPEG or PNG only.");
        setIsloading(false);
        return;
      }

      let imageUrl = null;

      if (file.type === "application/pdf") {
        if (!props?.edition) {
          message.error("Select Edition");
          setIsloading(false);
          return;
        }
        try {
          const edition = props.edition;
          const date = props.date;
          const up: any = await convertApi(file, "thumb", 0, 1, edition, date);

          imageUrl = up?.image_url;
          if (!imageUrl) {
            throw new Error("No image URL returned from convertApi");
          }
        } catch (apiError) {
          console.warn(
            "convertApi failed, falling back to local conversion:",
            apiError
          );
          imageUrl = await convertPdfToImage(file);
          if (!imageUrl) {
            setIsloading(false);
            return;
          }
        }
      } else {
        try {
          const uploadResponse = await uploadImageToS3(file);

          console.log("S3 Upload Response:========>>>>>>", uploadResponse.data);

          imageUrl = uploadResponse.data?.data;

          if (!imageUrl) {
            console.error(
              "No URL returned from S3 upload. Full response:",
              uploadResponse.data
            );
            message.error("Upload successful but no URL returned from server");
            setIsloading(false);
            return;
          }

          console.log("S3 Image URL:", imageUrl);
          message.success("Image uploaded successfully!");
        } catch (uploadError: any) {
          console.error("S3 upload failed:", uploadError);
          console.error("Error details:", {
            message: uploadError.message,
            status: uploadError.response?.status,
            statusText: uploadError.response?.statusText,
            url: uploadError.config?.url,
            method: uploadError.config?.method,
          });

          message.error(
            `Failed to upload image: ${
              uploadError.response?.status || "Network Error"
            }`
          );
          setIsloading(false);
          return;
        }
      }

      if (typeof props?.onChange === "function") {
        console.log(imageUrl, "imageUrlimageUrlimageUrlimageUrl");
        props.onChange(imageUrl);
      } else {
        console.warn("onChange callback is not provided or not a function");
        message.warning("Thumbnail uploaded, but no callback to handle it.");
      }

      setIsloading(false);
    } catch (error) {
      console.error("Upload error:", error);
      setIsloading(false);
      message.error("Failed to upload file");
    }
  };

  return (
    <Dropzone
      onDrop={uploadImage}
      accept={{
        "image/jpeg": [".jpeg", ".jpg"],
        "image/png": [".png"],
      }}
      multiple={false}
    >
      {({ getRootProps, getInputProps }) => (
        <section className="Epaper-ThumbnailPicker">
          <div className="Epaper-ThumbnailPickerBox">
            {isloading ? (
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />}
              />
            ) : null}
          </div>
          <div
            {...getRootProps({
              className: `ImagePicker-backgroud2 ${props?.size ? "small" : ""}`,
            })}
          >
            <input {...getInputProps()} />
            {props.fileURL ? (
              <img
                src={props.fileURL}
                className="Epaper-ThumbnailImage"
                alt="Thumbnail"
              />
            ) : (
              <div className="Epaper-PagesListBox">
                {isloading ? (
                  <div>Uploading...</div>
                ) : (
                  <FiUploadCloud size={30} />
                )}
                <div>
                  Upload Thumbnail (JPEG, PNG Format Only)
                  <br /> Size: 500x707 pixels
                </div>
              </div>
            )}
          </div>
        </section>
      )}
    </Dropzone>
  );
}

export default ThumbnailPicker;
